import _default from './WindowScroller';
export { _default as default };
import _WindowScroller from './WindowScroller';
export { _WindowScroller as WindowScroller };

export { IS_SCROLLING_TIMEOUT } from './utils/onScroll';